import { getJwt, hasRead } from '../helpers/jwt';
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthComponent = ({ children }) => {
    let location = useLocation();

    if (!getJwt()) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!hasRead()) {
        localStorage.removeItem("user_jwt");

        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children ? children : <Outlet />;
};

export default AuthComponent;